import cls from './Sound.module.scss';
import soundOff from '../../assets/images/sound-off.svg';
import soundOn from '../../assets/images/sound-on.svg';
import bgSound from '../../assets/images/bg-sound.svg';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import { toggleSound } from '../../redux/page/slice';
import { useEffect } from 'react';
import { sounds } from './assets';

export const Sound = () => {
  const dispatch = useDispatch();
  const { isSound } = useSelector((state: RootState) => state.page);
  const { isGame, isPause } = useSelector((state: RootState) => state.game);

  useEffect(() => {
    if (isSound) {
      if (!isGame) {
        sounds.bg.play();
        sounds.game.pause();
      } else {
        sounds.bg.pause();
        sounds.game.play();
      }
    }
  }, [isGame, isSound]);

  useEffect(() => {
    if (isSound) {
      if (isGame && !isPause) {
        sounds.bg_game.play();
      } else {
        sounds.bg_game.pause();
      }
    } else {
      sounds.bg_game.pause();
      sounds.bg.pause();
      sounds.game.pause();
    }
  }, [isGame, isSound, isPause]);

  return (
    <div className={cls.button} onClick={() => dispatch(toggleSound())}>
      <img alt="sound bg" src={bgSound} className={cls.bgSound}></img>
      {isSound ? (
        <img alt="Sound Off" src={soundOn} className={cls.sound} />
      ) : (
        <img alt="Sound Off" src={soundOff} className={cls.sound} />
      )}
    </div>
  );
};
